import { fmtSPURR } from "./fmt";

export default function TradeHistory({ trades }) {
  return (
    <div className="col-span-12 border border-[#3a3a3a] bg-[#121212]" data-testid="trade-history">
      <div className="px-6 py-4 border-b border-[#3a3a3a] flex items-center justify-between">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d0d0d0]">
          Trade History
        </div>
        <div className="font-mono text-[11px] text-[#d0d0d0]">
          {trades.length} trade{trades.length === 1 ? "" : "s"}
        </div>
      </div>
      {trades.length === 0 ? (
        <div className="px-6 py-12 text-center text-sm text-[#d0d0d0]">
          No trades yet. Buy your first SPURR to see this fill up.
        </div>
      ) : (
        <div className="divide-y divide-[#2a2a2a]">
          <div className="grid grid-cols-6 px-6 py-3 font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0]">
            <div>Side</div>
            <div>Price</div>
            <div className="text-right">SPURR</div>
            <div className="text-right">USD</div>
            <div className="col-span-2 text-right">Time</div>
          </div>
          {trades.map((t) => (
            <div
              key={t.id}
              className="grid grid-cols-6 px-6 py-3 font-mono text-xs hover:bg-[#1a1a1a]"
              data-testid={`trade-row-${t.id}`}
            >
              <div className={t.side === "buy" ? "text-[#00ff41]" : "text-[#ff3333]"}>
                {t.side.toUpperCase()}
              </div>
              <div>${(Number(t.price) || 0).toFixed(8)}</div>
              <div className="text-right">{fmtSPURR(t.emg_amount)}</div>
              <div className="text-right">${(Number(t.amount_usd) || 0).toFixed(2)}</div>
              <div className="col-span-2 text-right text-[#e2e2e2]">
                {new Date(t.timestamp).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
